import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import generateId from './generateId';
import { updateHashProps, rewriteUserId } from '../general';
import { addDatasToSave, loadDbModel } from './workBackendSlice';
import { saveAllData, saveData, deleteData, SignUpPayload } from './dataBackend';

export type RelationUserFolderDb = {
  userId: string;
  folderId: string;
  order: number;
}
const initial: RelationUserFolderDb = {
  userId: '',
  folderId: '',
  order: 0
};

export type RelationUserFolderDbHashType = {
  [key in string]: RelationUserFolderDb;
}

export type RelationUserFolderAddPayload = {
  id?: string;
} & RelationUserFolderDb;
export type RelationUserFolderUpdatePayload = {
  id: string;
} & { [P in keyof RelationUserFolderDb]?: RelationUserFolderDb[P] };

export type RelationUserFolderDbState = {
  relationUserFolders: RelationUserFolderDbHashType;
}

export const  generateRelationUserFolderId = () : string =>  generateId('ruf');
let initialState: RelationUserFolderDbState = { relationUserFolders: {} };
const key = 'relationUserFolders';

const relationUserFolderDbSlice = createSlice({
  name: 'relationUserFolderDb',
  initialState,
  reducers: {
    initializeRelationUserFolders(state: RelationUserFolderDbState) {
      state.relationUserFolders = {};
    },
    addRelationUserFolder(state: RelationUserFolderDbState, action: PayloadAction<RelationUserFolderAddPayload>) {
      let { id, ...obj } = action.payload;
      if (!id) id = generateRelationUserFolderId();
      state.relationUserFolders[id] = obj;
      saveData(key, id, obj);
    },
    updateRelationUserFolder(state: RelationUserFolderDbState, action: PayloadAction<RelationUserFolderUpdatePayload>) {
      const { id, ...obj } = action.payload;
      if (state.relationUserFolders[id] === undefined) {
        console.log(`*** RelationUserFolder not found: ${id}`);
      } else {
        const newData = { ...state.relationUserFolders[id], ...obj };
        state.relationUserFolders[id] = newData;
        saveData(key, id, newData);
      }
    },
    deleteRelationUserFolder(state: RelationUserFolderDbState, action: PayloadAction<RelationUserFolderUpdatePayload>) {
      const id = action.payload.id;
      delete state.relationUserFolders[id];
      deleteData(key, id);
    },
    saveRelationUserFolders(state: RelationUserFolderDbState) {
      saveAllData(key, state.relationUserFolders);
    },
    signUpRelationUserFolders(state: RelationUserFolderDbState, action: PayloadAction<SignUpPayload>) {
      const values = rewriteUserId(state.relationUserFolders, action.payload);
      addDatasToSave(key, values);
    }
  },
  extraReducers: (builder) => {
    builder.addCase(loadDbModel(key).fulfilled, (state: RelationUserFolderDbState, action) => {
      const values = action.payload;
      const [changed, updatedValues] = updateHashProps(initial, values);
      state.relationUserFolders = updatedValues;
      if (changed) saveAllData(key, state.relationUserFolders);
    })
  }
})

export const { initializeRelationUserFolders, addRelationUserFolder, updateRelationUserFolder, deleteRelationUserFolder, saveRelationUserFolders, signUpRelationUserFolders } = relationUserFolderDbSlice.actions;
export default relationUserFolderDbSlice.reducer;
